import { Routes, RouterModule } from '@angular/router';
import {ComingSoonComponent }from './Coming-soon.component';
const routes: Routes = [
  { path:'',component:ComingSoonComponent },
];

export const ComingSoonRoutes = RouterModule.forChild(routes);
